import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { TabNames, c1, offcanvasColors } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { Menu, Tab } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { GetCustomSchema } from "src/app/core/services/outbound";
import { WebsocketService } from "src/app/core/services/websocket.service";
@Component({
  selector: "app-tab-set-appbar-component",
  templateUrl: "./tab-set-appbar-component.component.html",
  styleUrls: ["./tab-set-appbar-component.component.scss"],
})
export class TabSetAppBarComponent implements OnInit, OnDestroy {
  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private modalService: BsModalService
  ) {}

  @Input() tab_id: string;
  @Input() config: any;
  tab: Tab;
  mode: string;
  component_ref;

  // default values
  imageLg: string;
  imageSm: string;
  image: string;
  icon: any;
  icon_ios: any;
  title: string;
  roundedBottom = true;
  offCanvasSubscription: any;
  currentTabSubscription: any;
  getContentSchemaSubscribtion: any;

  enableStickyPost = false;
  textColor = "#ffffff";
  stickyBgColor = "#ff2121";
  offcanvasColors = offcanvasColors;

  off_canvas_key: string = "tab";
  newTab = false;
  videoUrl = "";
  videoDesc = "";
  bgColor = "";
  modalRef?: BsModalRef;
  isAndroid: boolean;
  data: any;
  tabList = {};
  sortedTabList = [];
  current_tab_id;
  component_id: string;
  nextTab: Tab;
  menu: Menu;
  field_id: string;
  chatId: string = "";
  selectedBots = [];
  showJsonField = false;
  formattedJson = "";
  menuId: string;

  jsonData = {
    name: "John Doe",
    email: "john@example.com",
    role: "Admin",
    permissions: ["read", "write", "delete"],
  };

  ngOnInit() {
    this.field_id = "tab_set_appbar";
    this.component_ref = this.mdw.makeRef(16);
    this.currentTabSubscription = this.mdw.currentTabContainer$.subscribe(
      (data) => {
        console.log ("data TabsetAppbar", data)
        if (
          data &&
          (data["cat"] == "home" || data["cat"] == "side") &&
          data.target === "tabSetting" &&
          data.current_tab &&
          this.tab_id &&
          data.current_tab.id == this.tab_id &&
          data["component_id"] != this.component_id
        ) {
          this.data = data;
          this.sortedTabList = this.data["sortedTabList"];
          this.tabList = this.data["tabList"];
          this.tab = data["tabList"][this.tab_id];
          this.tabFunction();
        }
      }
    );

    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "tab" &&
          data.tab &&
          data.tab.id == this.tab_id
        ) {
          this.TabIntialize(data);
          this.tabFunction();
        }
      }
    );

    this.getContentSchemaSubscribtion =
      this.ws.getSetContentSchemaContainer$.subscribe(
        (getContentSchemaResponse) => {
          if (getContentSchemaResponse && getContentSchemaResponse.schema) {
            // localStorage.setItem("custom", getContentSchemaResponse.schema.schema_id);
            this.mdw.saveContentSchema(
              getContentSchemaResponse.schema,
              "appbar",
              false,
              true
            );
          }
        }
      );
  }

  TabIntialize(data) {
    this.data = data.data;
    if (data.tab.id == this.tab_id) {
      this.tab = { ...data.tab };
      this.component_id = this.tab.id + this.field_id;
    }
    this.sortedTabList = this.data["sortedTabList"];
    this.tabList = this.data["tabList"];
    this.mode = localStorage.getItem("mode");
  }

  tabFunction() {
    if (this.tab) {
      this.isAndroid =  localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;

      if (this.tab["appbar"]) {
        this.chatId = this.tab["appbar"].id;
        const menu = this.indexDBService.getItem("menu", this.tab["appbar"].menu_id   );
        menu.onsuccess = (event) => {
          if (menu.result) {
            this.menu = menu.result;
            this.menuId = menu.result.menu_id;

            const tab = this.indexDBService.getItem("tab", menu.result.menu_group  );
            tab.onsuccess = (event) => {
              if (tab.result) {
                this.nextTab = { ...tab.result };
              }
            };
          }
        };
      }
    }
  }

  openUsersSelector(changeRoll) {
   this.modalRef = this.modalService.show(changeRoll, {
      class: "modal-xl modal-dialog-centered",
    });
  //  this.mdw.changeTab({tab:{ module: "appbar" }}, this.mode, true, false, true);
  //   console.log("appbar")
  }

  selectedUsersf(item) {
    this.chatId = item[0].id;
    this.tab["appbar"] = { menu_id: item[0].menu_id, id: item[0].id };
    this.mdw.saveContentSchema(item[0], "appbar", false, true);
    this.updateTabData();
    this.mdw._appbarContainer.next({isAppbar:true, cat:"component", menu_id:item[0].menu_id})
    this.modalRef.hide();
  }

  onSelectScreen(event) {
    this.chatId = event.data.menu_id;
    this.tab["appbar"] = { menu_id: this.chatId, id: null };
    // this.mdw.saveContentSchema(item[0], "appbar", false, true);
    // this.nextTab = event;
    const menu = this.indexDBService.getItem("menu", this.chatId);
    menu.onsuccess = (event) => {
      if (menu.result) {
        this.menu = menu.result;
        this.menuId = menu.result.menu_id;
        const tab = this.indexDBService.getItem("tab", menu.result.menu_group);
        tab.onsuccess = (event) => {
          if (tab.result) {
            this.nextTab = { ...tab.result };
          }
        };
      }
    };
    this.updateTabData();
    this.modalRef.hide();
  }
  deleteTab() {
    delete this.tab["appbar"];
    this.nextTab = null;
    this.mdw._appbarContainer.next({appbar:false, cat:"compoenent", menu_id:null})
    this.updateTabData();
  }

  updateTabData() {
    //*must be there in all Tabs

    console.log ("this.tabList",this.tabList)

    this.tabList[this.tab_id] = this.tab;
    let index = this.sortedTabList.findIndex((e) => e.id == this.tab_id);
    this.sortedTabList[index] = { ...this.tab };
    this.data["sortedTabList"] = this.sortedTabList;
    this.data["TabList"] = this.tabList;
    this.data["off_canvas_key"] = this.off_canvas_key;
    this.data["current_tab"] = this.tab;
    this.data["target"] = "tabSetting";
    this.data["component_id"] = this.component_id;

    this.mdw._currentTabContainer.next(this.data);
    this.mdw.changeTab({ tab: this.tab }, this.mode, false);
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
    if (this.currentTabSubscription) {
      this.currentTabSubscription.unsubscribe();
    }
    if (this.getContentSchemaSubscribtion) {
      this.getContentSchemaSubscribtion.unsubscribe();
    }
  }
}
